import { render } from "./StatusMessage.vue?vue&type=template&id=2ff24fbc"
import script from "./StatusMessage.vue?vue&type=script&lang=js"
export * from "./StatusMessage.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__